"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'password.reset.hero.title': 'Hai dimenticato la password?',
    'password.reset.hero.description': 'Non preoccuparti, capita a tutti. Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.',
    'password.reset.hero.login_link_text': 'Ti ricordi la password?',
    'password.reset.hero.login_link': 'Accedi qui',
    'password.reset.page.title': 'Reimpostazione Password',
    'password.reset.form.title': 'Reimposta la tua Password',
    'password.reset.email.label': 'Indirizzo Email',
    'password.reset.email.placeholder': 'Inserisci il tuo indirizzo email',
    'password.reset.submit': 'Invia Link di Reimpostazione',
    'password.reset.backToLogin': 'Torna al Login',
    'password.reset.success.title': 'Email Inviata!',
    'password.reset.success.description': 'Controlla la tua email per le istruzioni su come reimpostare la password.',
    'password.reset.confirm.hero.title': 'Imposta Nuova Password',
    'password.reset.confirm.hero.description': 'Crea una password forte che ricorderai. La tua nuova password dovrebbe essere diversa da quella precedente.',
    'password.reset.confirm.hero.login_link_text': 'Ti ricordi la password?',
    'password.reset.confirm.hero.login_link': 'Accedi qui',
    'password.reset.confirm.page.title': 'Imposta Nuova Password',
    'password.reset.confirm.form.title': 'Crea Nuova Password',
    'password.reset.confirm.password.label': 'Nuova Password',
    'password.reset.confirm.password.placeholder': 'Inserisci nuova password',
    'password.reset.confirm.confirmPassword.label': 'Conferma Password',
    'password.reset.confirm.confirmPassword.placeholder': 'Conferma nuova password',
    'password.reset.confirm.submit': 'Reimposta Password',
    'password.reset.confirm.success.title': 'Password Reimpostata!',
    'password.reset.confirm.success.description': 'La tua password è stata reimpostata con successo. Ora puoi accedere con la tua nuova password.',
};
